module.exports = __webpack_public_path__ + "static/media/gp9.03db81fb.webp";